import { render, staticRenderFns } from "./OutstandingCreditListSideMenu.vue?vue&type=template&id=408c2bbe&scoped=true"
import script from "./OutstandingCreditListSideMenu.vue?vue&type=script&lang=js"
export * from "./OutstandingCreditListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c2bbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408c2bbe')) {
      api.createRecord('408c2bbe', component.options)
    } else {
      api.reload('408c2bbe', component.options)
    }
    module.hot.accept("./OutstandingCreditListSideMenu.vue?vue&type=template&id=408c2bbe&scoped=true", function () {
      api.rerender('408c2bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/outstandingcredit/OutstandingCreditListSideMenu.vue"
export default component.exports